import algoliarecommend from '@algolia/recommend'
import algoliaConfig from './algolia-config'

const initRecommendClient = () => {
  return algoliarecommend(algoliaConfig.siteId, algoliaConfig.apiKey)
}

export {
  initRecommendClient
}
